import { render, staticRenderFns } from "./target.vue?vue&type=template&id=47e7a0f2&scoped=true"
import script from "./target.vue?vue&type=script&lang=js"
export * from "./target.vue?vue&type=script&lang=js"
import style0 from "./target.vue?vue&type=style&index=0&id=47e7a0f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e7a0f2",
  null
  
)

export default component.exports